import { Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dark_blue, linkStyle } from "../../theme";
import moment from "moment";
import { useEffect, useState } from "react";
import { getScale, getScreenSize, getTitleSize } from "../../utils/getScreenSize";
import { TermsConditionText } from "./TermsConditionText";



export function TermsCond() {
  const { t } = useTranslation();
  const [numPages, setNumPages] = useState<number | null>(null);
  const [page, setPage] = useState<number>(0);
  const [scale, setScale] = useState<number>(1);
  const [title_size, setTitleSize] = useState<string>("h5");


  useEffect(() => {
    const width = window.screen.width;
    const size = getScreenSize(width);
    const scale = getScale(size);
    setScale(scale);
    const title_size: "h5" | "h6" = getTitleSize(size);
    setTitleSize(title_size);
  }, []);

  // @ts-ignore

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <Grid container style={{display: 'flex', marginTop: '10em', marginBottom:'8em', justifyContent: 'center', textAlign:'justify'}} spacing={3} >
      <Grid item lg={8}  xs={12}>
        <Typography variant={title_size as "h5" | "h6"} sx={{ fontWeight: "bold", color: dark_blue, textAlign: "center" }}>
          <Link style={linkStyle} to="/registration">
     Go Back
          </Link>
        </Typography>
      </Grid>
      <Grid item lg={8}xs={12}>
        <Typography variant={title_size as "h5" | "h6"} sx={{ fontWeight: "bold", color: dark_blue, textAlign: "center" }}>
    Terms of use
        </Typography>
        <Typography variant={title_size as "h5" | "h6"} sx={{ fontWeight: "bold", color: dark_blue, textAlign: "center" }}>
        Effective Date: 13 September, 2023
        </Typography>
      </Grid>
      <Grid item lg={8} xs={12}>
        <TermsConditionText />
      </Grid>
      {/* <Grid item xs={12} sm={12} md={8} lg={8} xl={8} sx={{ mmargin: "0px, auto" }}>
        <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from(new Array(numPages), (el, index) => (
            <Paper>
              <Page scale={scale} key={`page_${index + 1}`} pageNumber={index + 1} />
            </Paper>
          ))}
        </Document>
      </Grid> */}

      <Grid item  lg={8}  xs={12} sx={{ zIndex: 1 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: dark_blue, textAlign: "center", merginTop: -2 }}>
          <Link style={linkStyle} to="/registration">
   Go Back
          </Link>
        </Typography>
      </Grid>
    </Grid>
  );
}
